export default __webpack_public_path__ + "static/media/DNo.9-0.44ecd1a6.jpg";